import { render } from "./SubHero.vue?vue&type=template&id=1e67e200&scoped=true"
import script from "./SubHero.vue?vue&type=script&lang=js"
export * from "./SubHero.vue?vue&type=script&lang=js"

import "./SubHero.vue?vue&type=style&index=0&id=1e67e200&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e67e200"]])

export default __exports__